import { render, staticRenderFns } from "./ModalHistoricoAlteracoes.vue?vue&type=template&id=11dedd4f&scoped=true"
import script from "./ModalHistoricoAlteracoes.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoAlteracoes.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoAlteracoes.vue?vue&type=style&index=0&id=11dedd4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dedd4f",
  null
  
)

export default component.exports